// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_lTMWQ {
  font: normal 16px/150% var( --vf-Inter );
  color: #394756;
}
.text_lTMWQ a {
  color: var( --color-linkNormal );
  text-decoration: none;
}
.text_lTMWQ a:hover {
  color: var( --color-linkHover );
}
.text_lTMWQ a:active {
  color: var( --color-linkVisited );
}
.text_lTMWQ a:focus {
  color: var( --color-linkVisited );
}
.text_lTMWQ a:visited {
  color: var( --color-linkVisited );
}
.text_lTMWQ.text-title_WfPPM {
  font: bold 20px/28px var( --vf-Inter );
  color: #181e25;
}
.text_lTMWQ.text-subtitle_t9FZZ {
  font: bold 16px/24px var( --vf-Inter );
  color: #394756;
}
.text_lTMWQ.text-body_imp3J {
  font: normal 16px/26px var( --vf-Inter );
  color: #394756;
}
.text_lTMWQ.text-bodySmall_VKpbM {
  font: normal 15px/24px var( --vf-Inter );
  color: #394756;
}
.text_lTMWQ.text-caption_G4Unj {
  font: 13px/20px var( --vf-Inter );
  color: #394756;
}
.text_lTMWQ.text-captionSmall_Hur6o {
  font: normal 12px/18px var( --vf-Inter );
  color: #394756;
}
.text_lTMWQ.text-subtitle_t9FZZ.text-navLogoLabel_Qd6GS {
  font: bold 16px/24px var( --vf-Inter );
  color: var( --color-white );
}
.text_lTMWQ.text-title_WfPPM.text-pageTitle_mL8wF {
  line-height: 24px;
}
.text_lTMWQ.text-title_WfPPM.text-sidebarTitle_k19qW {
  color: var( --color-base700 );
}
.text_lTMWQ.text-title_WfPPM.text-formTitle_9UDmF {
  font: bold 18px/24px var( --vf-Inter );
  color: var( --color-base700 );
}
.text_lTMWQ.text-subtitle_t9FZZ.text-listItemTitle_hIUTK {
  font-weight: 600;
}
.text_lTMWQ.text-captionSmall_Hur6o.text-inputCaptionSmall_MfzSa.text-inputCaptionSmallError_tmzqO {
  color: var( --color-danger500 );
}
.text_lTMWQ.text-bodySmall_VKpbM.text-loginWarning_jPgNt {
  color: var( --color-danger500 );
  font-weight: 600;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-mobileMapTitle_bfnfj {
  color: var( --color-white );
  font-weight: bold;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-mobileTitle_uypJS {
  font-weight: 600;
}
.text_lTMWQ.text-captionBold_h1clF {
  font: 600 13px/20px var( --vf-Inter );
  color: #394756;
}
.text_lTMWQ.text-captionSmallBold_L3Rrx {
  font: 600 12px/18px var( --vf-Inter );
  color: #394756;
}`, "",{"version":3,"sources":["webpack://./src/theme/Text.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB","sourcesContent":[".text {\n  font: normal 16px/150% var( --vf-Inter );\n  color: #394756;\n}\n.text a {\n  color: var( --color-linkNormal );\n  text-decoration: none;\n}\n.text a:hover {\n  color: var( --color-linkHover );\n}\n.text a:active {\n  color: var( --color-linkVisited );\n}\n.text a:focus {\n  color: var( --color-linkVisited );\n}\n.text a:visited {\n  color: var( --color-linkVisited );\n}\n.text.text-title {\n  font: bold 20px/28px var( --vf-Inter );\n  color: #181e25;\n}\n.text.text-subtitle {\n  font: bold 16px/24px var( --vf-Inter );\n  color: #394756;\n}\n.text.text-body {\n  font: normal 16px/26px var( --vf-Inter );\n  color: #394756;\n}\n.text.text-bodySmall {\n  font: normal 15px/24px var( --vf-Inter );\n  color: #394756;\n}\n.text.text-caption {\n  font: 13px/20px var( --vf-Inter );\n  color: #394756;\n}\n.text.text-captionSmall {\n  font: normal 12px/18px var( --vf-Inter );\n  color: #394756;\n}\n.text.text-subtitle.text-navLogoLabel {\n  font: bold 16px/24px var( --vf-Inter );\n  color: var( --color-white );\n}\n.text.text-title.text-pageTitle {\n  line-height: 24px;\n}\n.text.text-title.text-sidebarTitle {\n  color: var( --color-base700 );\n}\n.text.text-title.text-formTitle {\n  font: bold 18px/24px var( --vf-Inter );\n  color: var( --color-base700 );\n}\n.text.text-subtitle.text-listItemTitle {\n  font-weight: 600;\n}\n.text.text-captionSmall.text-inputCaptionSmall.text-inputCaptionSmallError {\n  color: var( --color-danger500 );\n}\n.text.text-bodySmall.text-loginWarning {\n  color: var( --color-danger500 );\n  font-weight: 600;\n}\n.text.text-bodySmall.text-mobileMapTitle {\n  color: var( --color-white );\n  font-weight: bold;\n}\n.text.text-bodySmall.text-mobileTitle {\n  font-weight: 600;\n}\n.text.text-captionBold {\n  font: 600 13px/20px var( --vf-Inter );\n  color: #394756;\n}\n.text.text-captionSmallBold {\n  font: 600 12px/18px var( --vf-Inter );\n  color: #394756;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `text_lTMWQ`,
	"text-title": `text-title_WfPPM`,
	"text-subtitle": `text-subtitle_t9FZZ`,
	"text-body": `text-body_imp3J`,
	"text-bodySmall": `text-bodySmall_VKpbM`,
	"text-caption": `text-caption_G4Unj`,
	"text-captionSmall": `text-captionSmall_Hur6o`,
	"text-navLogoLabel": `text-navLogoLabel_Qd6GS`,
	"text-pageTitle": `text-pageTitle_mL8wF`,
	"text-sidebarTitle": `text-sidebarTitle_k19qW`,
	"text-formTitle": `text-formTitle_9UDmF`,
	"text-listItemTitle": `text-listItemTitle_hIUTK`,
	"text-inputCaptionSmall": `text-inputCaptionSmall_MfzSa`,
	"text-inputCaptionSmallError": `text-inputCaptionSmallError_tmzqO`,
	"text-loginWarning": `text-loginWarning_jPgNt`,
	"text-mobileMapTitle": `text-mobileMapTitle_bfnfj`,
	"text-mobileTitle": `text-mobileTitle_uypJS`,
	"text-captionBold": `text-captionBold_h1clF`,
	"text-captionSmallBold": `text-captionSmallBold_L3Rrx`
};
export default ___CSS_LOADER_EXPORT___;
